import React from 'react';
import { InsertDriveFileOutlined as DocumentIcon } from '@mui/icons-material';
import { Box, Button, IconButton, Paper, Typography, useTheme } from '@mui/material';

interface AddRuleCardProps {
  onAddManual: () => void;
  onUpload: () => void;
}

export const AddRuleCard: React.FC<AddRuleCardProps> = ({ onAddManual, onUpload }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        bgcolor: '#F8F9FB', // Light gray background from image
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mb: 0.5 }}>
        Add New Rules
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
        Upload Document
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          variant="outlined"
          onClick={onAddManual}
          sx={{
            color: '#2D336B',
            borderColor: '#2D336B',
            textTransform: 'none',
            borderRadius: '20px', // Pill shape from image
            px: 3,
            fontWeight: 600,
            '&:hover': {
              borderColor: '#1E2248',
              bgcolor: 'rgba(45, 51, 107, 0.04)',
            },
          }}
        >
          Input Manually
        </Button>
        <IconButton
          onClick={onUpload}
          sx={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: '8px',
            color: '#2D336B',
          }}
        >
          <DocumentIcon />
        </IconButton>
      </Box>
    </Paper>
  );
};

